export const getAttributes = (classes, labels, link, linkProps, sitemap) => {
	const attributes = {};
	const { href = '', params = '' } = linkProps[link];
	const path = sitemap.has(href) ? sitemap.get(href) : '/404.htm';

	switch (link) {
		case 'EMAIL':
			Object.assign(attributes, {
				className: `${classes} dialog`,
				'data-href': `${path}${params}`,
				'data-title': labels.get(linkProps[link].label)
			});
			break;
		default: // Do nothing
	}

	return attributes;
};
